// src/config/featureFlags.js
// Centralized feature flag configuration

const inventoryFlagFromEnv = process.env.REACT_APP_ENABLE_INVENTORY;
const receivablesFlagFromEnv = process.env.REACT_APP_ENABLE_RECEIVABLES;

const parseBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim().toLowerCase();
  if (['true', '1', 'yes', 'y', 'on'].includes(normalized)) return true;
  if (['false', '0', 'no', 'n', 'off'].includes(normalized)) return false;
  return undefined;
};

const defaultFlags = {
  inventory: false,
  receivables: true,
};

const runtimeFlags = {
  inventory: parseBoolean(inventoryFlagFromEnv),
  receivables: parseBoolean(receivablesFlagFromEnv),
};

export const getFeatureFlags = () => ({
  ...defaultFlags,
  ...Object.fromEntries(
    Object.entries(runtimeFlags).filter(([, value]) => typeof value === 'boolean')
  ),
});


